import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import ProtectedRoute from './auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import GeneratorPage from './pages/GeneratorPage';
import HistoryPage from './pages/HistoryPage';
import CreditsPage from './pages/CreditsPage';
import FavouritesPage from './pages/catalog/FavouritesPage';
import LibraryPage from './pages/LibraryPage';
import { AudienceTracker } from './audience/AudienceTracker';
import { GoogleAnalytics } from './audience/GoogleAnalytics';

/**
 * app.mixgenie.ai — the generator/library app. This bundle has no
 * catalog / lyric surface (that lives on dicelacancion.com's own
 * bundle) and no CONVERSION_ENABLED gate — auth, generator, credits
 * are always on because that's the whole point of this surface.
 *
 * Default route is `/generator`. Anonymous visits land on `/login`
 * via ProtectedRoute, then bounce back to the generator on success.
 */
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AudienceTracker />
        <GoogleAnalytics />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />

          <Route path="/generator" element={<ProtectedRoute><GeneratorPage /></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
          <Route path="/songs" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
          <Route path="/credits" element={<ProtectedRoute><CreditsPage /></ProtectedRoute>} />
          <Route path="/favourites" element={<ProtectedRoute><FavouritesPage /></ProtectedRoute>} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/shared" element={<LibraryPage />} />

          <Route path="/" element={<Navigate to="/generator" replace />} />
          <Route path="*" element={<Navigate to="/generator" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
